import React from 'react';
const MonitoringIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3h18v18H3z" />
    <path d="M7 14l3-3 3 2 4-5" />
  </svg>
);
export default MonitoringIcon;